import React from 'react';
import PropTypes from 'prop-types';

import IconSlider from '@spothero/icons/slider';

import {Box, Button, Icon} from '@spothero/ui';

import Badge from 'common/badge/Badge';
import SearchInput from 'common/form-elements/SearchInput';
import {
    filterButtonStyleProps,
    filterCountBadgeOverlayStyleProps,
} from 'common/theme/Button.styles';

const inputStyleProps = {
    backgroundColor: 'gray.light',
    paddingRight: 10,
    minWidth: '100%',
    width: '100%',
};

const FacilitySearch = ({
    defaultValue,
    label,
    numFiltersApplied,
    onChange,
    onClear,
    onSubmit,
    onFiltersToggle,
}) => {
    const noFiltersApplied = numFiltersApplied === 0;

    return (
        <Box marginX={4}>
            <Box
                marginTop={2}
                marginBottom={4}
                display="flex"
                justifyContent="space-between"
                gap={4}
            >
                <SearchInput
                    label={label}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onClear={onClear}
                    onSubmit={onSubmit}
                    placeholder="Search Facilities"
                    showSubmitButton={false}
                    inputGroupProps={{width: '100%', display: 'block'}}
                    inputProps={inputStyleProps}
                    data-testid="FacilitySidebarSearchInput"
                />
                <Button
                    onClick={onFiltersToggle}
                    {...filterButtonStyleProps}
                    data-testid="FacilitySidebarFiltersButton"
                >
                    <Icon as={IconSlider} marginRight={2} />
                    Filters
                    {!noFiltersApplied ? (
                        <Badge {...filterCountBadgeOverlayStyleProps}>
                            {numFiltersApplied}
                        </Badge>
                    ) : null}
                </Button>
            </Box>
        </Box>
    );
};

FacilitySearch.propTypes = {
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    numFiltersApplied: PropTypes.number,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    onSubmit: PropTypes.func,
    onFiltersToggle: PropTypes.func,
};

export default FacilitySearch;
